var _rect, _path, _g, _ellipse, _ellipse2, _rect2, _path2, _path3, _path4, _rect3, _rect4, _path5, _path6, _path7, _g2, _path8, _rect5, _rect6, _path9, _circle, _path10, _circle2, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJobHistory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 280,
    viewBox: "0 0 600 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3830_509143)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 280,
    fill: "#E6F1FC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3830_509143",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -161,
    y: 0,
    width: 688,
    height: 283
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-160.229 0.335937H526.02V282.309H-160.229V0.335937Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3830_509143)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.797,
    cy: 82.306,
    rx: 50.9943,
    ry: 50.4115,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.0039,
    y: 86.0938,
    width: 111.313,
    height: 46.6234,
    rx: 23.3117,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.849,
    y: 137.305,
    width: 44.0947,
    height: 13.5676,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.848 150.873L119.091 116.954V103.387H163.186L264.943 137.306V150.873H220.848Z",
    fill: "#211E1F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.849,
    y: 150.873,
    width: 44.0947,
    height: 131.436,
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.1757,
    height: 20.3514,
    transform: "matrix(1 0 0 -1 244.595 183.096)",
    fill: "#FFC300"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.1757,
    height: 20.3514,
    transform: "matrix(1 0 0 -1 231.027 222.951)",
    fill: "#FFC300"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.091 116.953L220.848 150.872V282.308H119.091V116.953Z",
    fill: "#FFC300"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.091 116.954L220.848 150.873V137.305L119.091 103.386V116.954Z",
    fill: "#00172C"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.3514,
    height: 39.0069,
    transform: "matrix(1 0 0 -1 139.442 282.309)",
    fill: "#211E1F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.3514,
    height: 20.3514,
    transform: "matrix(1 0 0 -1 139.442 222.951)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.3514,
    height: 20.3514,
    transform: "matrix(1 0 0 -1 180.151 222.951)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.3514,
    height: 20.3514,
    transform: "matrix(1 0 0 -1 139.442 182.248)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.3514,
    height: 20.3514,
    transform: "matrix(1 0 0 -1 180.151 182.248)",
    fill: "#CC851A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 392.717,
    cy: 141.889,
    rx: 45.8206,
    ry: 45.2969,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.524,
    y: 145.293,
    width: 100.02,
    height: 41.8931,
    rx: 20.9466,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.3762,
    cy: 210.821,
    r: 29.9475,
    fill: "#FFC300"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.3759,
    cy: 183.771,
    r: 20.287,
    fill: "#FFC300"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.4102,
    y: 197.297,
    width: 1.9321,
    height: 85.0122,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3792 222.413L32.8545 205.99",
    stroke: "black",
    strokeWidth: 1.9321
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3779 231.107L56.0384 218.549",
    stroke: "black",
    strokeWidth: 1.9321
  }), /*#__PURE__*/React.createElement("circle", {
    r: 25.4795,
    transform: "matrix(-1 0 0 1 -0.497097 226.108)",
    fill: "#FFC300"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 20.287,
    transform: "matrix(-1 0 0 1 -1.06435 206.42)",
    fill: "#FFC300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.06081 233.737L12.4639 217.314",
    stroke: "black",
    strokeWidth: 1.9321
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.903 54.7497C210.903 68.2877 192.218 86.4004 192.218 86.4004C192.218 86.4004 173.533 68.8216 173.533 54.7497C173.533 42.7652 181.899 35.4414 192.218 35.4414C202.538 35.4414 210.903 42.7652 210.903 54.7497Z",
    fill: "#006EDF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 192.126,
    cy: 53.7673,
    rx: 11.1004,
    ry: 11.1267,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3830_509143)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3830_509143)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.356 58.0942C190.198 58.0942 190.04 58.0359 189.916 57.9193L187.697 55.823C187.441 55.5796 187.429 55.1742 187.673 54.9173C187.915 54.6605 188.321 54.6496 188.578 54.8917L190.356 56.5717L196.663 50.5844C196.919 50.341 197.325 50.3506 197.569 50.6081C197.813 50.8643 197.802 51.2697 197.546 51.5131L190.797 57.9181C190.674 58.0353 190.515 58.0942 190.356 58.0942Z",
    fill: "#211E1F"
  }))))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 557.604,
    cy: 210.054,
    rx: 29.605,
    ry: 29.8409,
    fill: "#FFC300"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 557.604,
    cy: 183.102,
    rx: 20.055,
    ry: 20.2148,
    fill: "#FFC300"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 556.649,
    y: 196.578,
    width: 1.91,
    height: 84.7097,
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M557.606 221.607L544.236 205.242",
    stroke: "black",
    strokeWidth: 1.9321
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M557.605 230.27L567.155 217.756",
    stroke: "black",
    strokeWidth: 1.9321
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.02 40.4629C320.718 40.4629 315.609 45.5715 315.609 51.8733V212.023C315.609 218.325 320.718 223.433 327.02 223.433H556.67C562.971 223.433 568.08 218.325 568.08 212.023V51.8733C568.08 45.5715 562.971 40.4629 556.67 40.4629H327.02ZM416.314 51.8097C413.18 51.8097 410.64 54.3498 410.64 57.4832C410.64 60.6166 413.18 63.1567 416.314 63.1567H468.793C471.927 63.1567 474.467 60.6166 474.467 57.4832C474.467 54.3498 471.927 51.8097 468.793 51.8097H416.314Z",
    fill: "#FDFDFD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 332.629,
    y: 85.8516,
    width: 78.0106,
    height: 78.0106,
    rx: 5.6735,
    fill: "#89D0FE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3830_509143",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 332,
    y: 85,
    width: 79,
    height: 79
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 332.629,
    y: 85.8516,
    width: 78.0106,
    height: 78.0106,
    rx: 5.6735,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3830_509143)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M357.746 108.707C355.968 99.8182 362.767 91.5254 371.831 91.5254C380.783 91.5254 387.554 99.6242 385.968 108.434L384.716 115.392L380.897 118.309H361.947L359.083 115.392L357.746 108.707Z",
    fill: "#9D4000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.337 123.152C380.337 123.152 379.898 129.089 379.898 132.27C379.898 136.348 387.178 139.817 393.417 142.041C398.605 143.891 402.636 148.303 403.314 153.77L407.851 190.36H335.463L340 153.77C340.678 148.303 344.708 143.89 349.902 142.055C356.14 139.852 363.416 136.432 363.416 132.468C363.416 129.302 362.977 123.592 362.977 123.592L380.337 123.152Z",
    fill: "#F8C9A8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3830_509143",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 335,
    y: 123,
    width: 73,
    height: 68
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.337 123.152C380.337 123.152 379.898 129.089 379.898 132.27C379.898 136.348 387.178 139.817 393.417 142.041C398.605 143.891 402.636 148.303 403.314 153.77L407.851 190.36H335.463L340 153.77C340.678 148.303 344.708 143.89 349.902 142.055C356.14 139.852 363.416 136.432 363.416 132.468C363.416 129.302 362.977 123.592 362.977 123.592L380.337 123.152Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3830_509143)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M362.005 134.902C362.005 134.902 363.421 140.694 371.877 140.693C380.333 140.691 381.309 134.902 381.309 134.902L402.186 142.323L407.851 184.979H335.463L341.128 142.89L362.005 134.902Z",
    fill: "#031D43"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M357.557 134.959L371.437 186.795H350.759L349.909 136.942L357.557 134.959Z",
    fill: "#006EDF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.849 153.461C356.523 153.461 356.264 153.641 356.264 153.859L356.465 156.083C356.485 156.216 356.652 156.32 356.849 156.32C357.05 156.32 357.217 156.216 357.241 156.083L357.438 153.859C357.438 153.641 357.179 153.461 356.849 153.461ZM353.779 155.282C353.587 155.173 353.3 155.306 353.137 155.585C352.969 155.865 352.998 156.178 353.194 156.287L355.234 157.231C355.364 157.274 355.536 157.183 355.637 157.013C355.737 156.842 355.728 156.648 355.622 156.562L353.779 155.282ZM360.514 156.287C360.706 156.178 360.734 155.865 360.572 155.585C360.404 155.306 360.117 155.173 359.925 155.282L358.081 156.562C357.976 156.648 357.966 156.842 358.067 157.013C358.168 157.183 358.34 157.274 358.469 157.231L360.514 156.287ZM353.194 159.128C352.998 159.242 352.969 159.555 353.137 159.835C353.3 160.114 353.587 160.247 353.779 160.138L355.622 158.858C355.728 158.768 355.737 158.573 355.637 158.403C355.536 158.232 355.364 158.142 355.234 158.189L353.194 159.128ZM358.469 158.189C358.34 158.142 358.168 158.232 358.067 158.403C357.966 158.573 357.976 158.768 358.081 158.858L359.925 160.138C360.117 160.247 360.404 160.114 360.572 159.835C360.734 159.555 360.706 159.242 360.514 159.128L358.469 158.189ZM356.853 159.099C356.652 159.099 356.485 159.198 356.465 159.331L356.264 161.555C356.264 161.778 356.523 161.958 356.849 161.958C357.179 161.958 357.438 161.778 357.438 161.555L357.241 159.331C357.217 159.198 357.05 159.099 356.853 159.099Z",
    fill: "#FEBC11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.742,
    y: 163.852,
    width: 8.21451,
    height: 3.11585,
    rx: 0.566518,
    fill: "#D5D6D8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.879 134.959L371.999 186.795H392.677L393.527 136.942L385.879 134.959Z",
    fill: "#006EDF"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M360.454 107.119C360.454 100.933 365.469 95.918 371.655 95.918C377.842 95.918 382.857 100.933 382.857 107.119V118.979C382.857 125.166 377.842 130.181 371.655 130.181C365.469 130.181 360.454 125.166 360.454 118.979V107.119Z",
    fill: "#F8C9A8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 379.346,
    y: 111.732,
    width: 6.589,
    height: 8.49835,
    rx: 2.6356,
    fill: "#F8C9A8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 357.382,
    y: 111.732,
    width: 6.589,
    height: 8.49835,
    rx: 2.6356,
    fill: "#F8C9A8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.454 97.6741L371.436 93.7207L382.857 97.6741L384.175 101.188L382.857 107.249C382.857 107.249 362.67 97.2524 361.715 102.503C360.76 107.754 360.454 113.927 360.454 113.927L358.697 105.581L360.454 97.6741Z",
    fill: "#9D4000"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 377.582,
    cy: 113.146,
    r: 1.3178,
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.68 122.246C367.68 122.219 368.434 121.863 368.458 121.875C368.778 122.021 369.228 122.158 369.862 122.251C371.054 122.428 371.42 122.458 373.142 122.341C373.774 122.298 374.235 122.122 374.566 121.917C374.769 121.79 375.317 121.991 375.317 122.231C375.317 122.244 375.316 122.258 375.312 122.271C375.273 122.418 374.953 123.353 373.153 123.446C371.198 123.546 370.829 123.525 369.862 123.382C368.225 123.139 367.72 122.32 367.682 122.255C367.68 122.252 367.68 122.25 367.68 122.246Z",
    fill: "#9D4000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 365.722,
    cy: 113.146,
    r: 1.3178,
    fill: "black"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 421.988,
    y: 85.8516,
    width: 127.654,
    height: 8.51024,
    rx: 4.25512,
    fill: "#00539D"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.243652,
    x: 421.988,
    y: 128.402,
    width: 85.1024,
    height: 8.51024,
    rx: 4.25512,
    fill: "#9B9B9B"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.243652,
    x: 421.988,
    y: 142.586,
    width: 42.5512,
    height: 8.51024,
    rx: 4.25512,
    fill: "#9B9B9B"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.243652,
    x: 421.988,
    y: 156.77,
    width: 42.5512,
    height: 8.51024,
    rx: 4.25512,
    fill: "#9B9B9B"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.243652,
    x: 542.549,
    y: 186.555,
    width: 8.51024,
    height: 22.694,
    rx: 4.25512,
    fill: "#9B9B9B"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.243652,
    x: 528.368,
    y: 186.555,
    width: 8.51024,
    height: 22.694,
    rx: 4.25512,
    fill: "#9B9B9B"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.243652,
    x: 497.161,
    y: 186.555,
    width: 25.5307,
    height: 22.694,
    rx: 4.25512,
    fill: "#9B9B9B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3830_509143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 280,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3830_509143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.5891,
    height: 13.5891,
    fill: "white",
    transform: "translate(186.753 48.3887)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3830_509143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.4567,
    height: 12.4567,
    fill: "white",
    transform: "translate(186.858 48.4863)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobHistory);
export default __webpack_public_path__ + "static/media/jobHistory.09a4a6b51e45d5e91d549b1dead5c567.svg";
export { ForwardRef as ReactComponent };